// cafm.frontend keeps provider and tenant internally through v1; only the
// wire speaks the renamed vocabulary (operator, occupier). Values are
// literals rather than RealmModel.TYPES to keep this module import-free.
const API_TO_INTERNAL = Object.freeze({
  operator: 'provider',
  occupier: 'tenant',
});

const INTERNAL_TO_API = Object.freeze({
  provider: 'operator',
  tenant: 'occupier',
});

/**
 * Translates an organization type arriving from the API into the internal
 * vocabulary. Unknown values pass through, so both the old and the renamed
 * backend vocabulary are tolerated.
 * @param {string} type
 * @returns {string}
 */
export const toInternalOrgType = (type) => API_TO_INTERNAL[type] || type;

/**
 * Translates an internal organization type into the renamed vocabulary the
 * API speaks. The backend must accept operator and occupier before a build
 * with this adapter is deployed.
 * @param {string} type
 * @returns {string}
 */
export const toApiOrgType = (type) => INTERNAL_TO_API[type] || type;
